<template>
  <div v-wechat-title="titleTop" class="exam-page">
    <!-- =========================
         VIEW 1: 开始考试（规则页）
         ========================= -->
    <div v-if="!examStart && data && data.baseData" class="view start-view">

<!-- Start View Main (match new HTML) -->
      <main class="start-main">
        <div class="start-card">
          <!-- Hero Image -->
          <div class="start-hero">
            <img
              class="start-hero-img"
              :src="data.baseData.cover || defaultHero"
              alt="hero"
            />
            <div class="start-hero-overlay">
              <div class="start-hero-text">
                <span class="start-badge">Exam</span>
                <h1 class="start-title">{{ data.baseData.title }}</h1>
              </div>
            </div>
          </div>

          <div class="start-content">
            <!-- Stats Grid -->
            <div class="start-stats">
              <div class="start-stat start-stat-blue">
                <div class="start-stat-icon">
                  <van-icon name="clock-o" size="18" />
                </div>
                <div class="start-stat-k">时长</div>
                <div class="start-stat-v">{{ data.baseData.timeMinute }} 分钟</div>
              </div>

              <div class="start-stat start-stat-purple">
                <div class="start-stat-icon">
                  <van-icon name="orders-o" size="18" />
                </div>
                <div class="start-stat-k">题量</div>
                <div class="start-stat-v">{{ data.baseData.totalNum }} 题</div>
              </div>

              <div class="start-stat start-stat-green">
                <div class="start-stat-icon">
                  <van-icon name="passed" size="18" />
                </div>
                <div class="start-stat-k">及格分</div>
                <div class="start-stat-v">{{ passScoreText }}</div>
              </div>
            </div>

            <!-- Instructions -->
            <div class="start-instructions">
              <h3 class="start-instructions-title">考试须知 (Instructions)</h3>
              <ul class="start-instructions-list">
                <li class="start-instructions-item">
                  <span class="start-ins-ico" aria-hidden="true">
                    <svg viewBox="0 0 24 24" class="start-ins-svg">
                      <path
                        fill="currentColor"
                        d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1 8h-2a1 1 0 0 1 0-2h1v-4h-1a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1Z"
                      />
                    </svg>
                  </span>
                  <span>请从每道题的选项中选择<strong class="start-strong">最佳答案</strong>。</span>
                </li>
                <li class="start-instructions-item">
                  <span class="start-ins-ico" aria-hidden="true">
                    <svg viewBox="0 0 24 24" class="start-ins-svg">
                      <path
                        fill="currentColor"
                        d="M12 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6.36-2.64-1.41 1.41a9.03 9.03 0 0 0-9.9 0l-1.41-1.41a11.03 11.03 0 0 1 12.72 0ZM21.19 12.5l-1.42 1.42a13.03 13.03 0 0 0-15.54 0L2.81 12.5a15.03 15.03 0 0 1 18.38 0ZM23 8.69l-1.41 1.41a17.03 17.03 0 0 0-19.18 0L1 8.69a19.03 19.03 0 0 1 22 0Z"
                      />
                    </svg>
                  </span>
                  <span>请保持网络连接稳定，中途退出可能导致进度丢失。</span>
                </li>
                <li class="start-instructions-item">
                  <span class="start-ins-ico" aria-hidden="true">
                    <svg viewBox="0 0 24 24" class="start-ins-svg">
                      <path
                        fill="currentColor"
                        d="M7 2a1 1 0 0 0-1 1v2H5a1 1 0 0 0 0 2h1v14H5a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2h-1V7h1a1 1 0 1 0 0-2h-1V3a1 1 0 0 0-1-1H7Zm1 3V4h8v1H8Zm0 2h8v14H8V7Zm2 2a1 1 0 0 0 0 2h.5V12H10a1 1 0 0 0 0 2h.5v1H10a1 1 0 0 0 0 2h.5v.5a1 1 0 0 0 2 0V17h1v.5a1 1 0 0 0 2 0V17h.5a1 1 0 1 0 0-2H15v-1h.5a1 1 0 1 0 0-2H15v-1h.5a1 1 0 1 0 0-2H10Z"
                      />
                    </svg>
                  </span>
                  <span>允许使用潜水电脑表或 eRDPml 计算器辅助作答。</span>
                </li>
              </ul>
            </div>

            <!-- User Info Confirmation -->
            <div class="start-student">
              <div class="start-avatar">
                <img :src="userData.icon?userData.icon:'/img/defaultIcon.jpg'"/>
              </div>
              <div class="start-student-meta">
                <div class="start-student-k">考生 (Student)</div>
                <div class="start-student-v">{{ GetUserName() }}</div>
              </div>
              <van-icon name="success" size="16" class="start-student-ok" />
            </div>

            <!-- 选择参与测验的顾客（旧逻辑保留，样式贴近新页面） -->
            <div
              v-if="!data.baseData.examResultId && data.baseData.examStudentInfo && data.baseData.examStudentInfo.length > 1"
              class="start-student-picker"
            >
              <div class="start-picker-title">请选择参与测验的顾客</div>
              <van-radio-group
                v-model="studentId"
                :checked-color="GetDiveMainBack()"
                class="start-picker-radio"
                @change="onSelectStudent"
              >
                <van-radio
                  v-for="item in data.baseData.examStudentInfo"
                  :key="item.studentId"
                  :name="item.studentId"
                  class="start-picker-line"
                >
                  {{ item.className }} {{ item.lastName }} {{ item.firstName }}
                </van-radio>
              </van-radio-group>
            </div>

            <div v-if="selectStudent && !selectStudent.isCanExam" class="warn">
              您已经参加过本次测验，不能重复参加，如需帮助请联系 <b>{{ data.baseData.coachName }}</b> 或客服。
            </div>

            <!-- Start Button (match new HTML) -->
            <button
              class="start-btn"
              type="button"
              :class="{ 'btn-disabled': startBtnDisabled }"
              :disabled="startBtnDisabled"
              @click="onStart"
            >
              <van-loading v-if="buttonLoading" size="18" type="spinner" class="start-btn-spinner" />
              <template v-else>
                <span>开始考试</span>
                <van-icon name="arrow" size="14" class="start-btn-arrow" />
              </template>
            </button>
            <p class="start-note">点击开始即代表您同意考试诚信协议</p>

            <div v-if="data.baseData.examResultId" class="remain">
              测验剩余时间：
              <van-count-down
                class="remain-timer"
                :time="data.baseData.examFinishTime"
                :format="data.baseData.examFinishTime > 3600000 ? 'HH时mm分ss秒' : 'mm分ss秒'"
              />
            </div>
          </div>
        </div>
      </main>

      <!-- Simple Footer (match new HTML) -->
      <footer class="start-footer">
        <p class="start-footer-text">&copy; Diveboss Technology Co., Ltd. All right reserved.</p>
      </footer>
    </div>

    
    <!-- =========================
         VIEW 2: 进行考试
         ========================= -->
    <div v-if="examStart && data && data.baseData" class="view exam-view">
      <!-- STICKY HEADER -->
      <header class="exam-header">
        <div class="exam-header-inner">
          <div class="exam-header-top">
            <div class="exam-header-qno">
              第
              <span class="exam-header-current">{{ questionIndex + 1 }}</span>
              <span class="exam-header-total">/{{ data.baseData.totalNum }}</span>
              题
            </div>

            <div class="exam-timer-pill">
              <van-icon name="clock-o" class="exam-timer-icon" />
              <van-count-down
                :time="data.baseData.examFinishTime"
                :format="data.baseData.examFinishTime > 3600000 ? 'HH:mm:ss' : 'mm:ss'"
                class="exam-timer-text"
              />
            </div>
          </div>

          <div class="exam-progress-track">
            <div class="exam-progress-bar" :style="{ width: progressPercent + '%' }" />
          </div>
        </div>
      </header>

      <!-- MAIN CONTENT -->
      <main class="exam-main">
        <transition name="slide" mode="out-in">
          <div :key="questionIndex" class="slide-container">
            <div v-if="questionData" class="exam-question-card">
              <span class="exam-question-type">{{ questionData.isMultiple ? '多选题' : '单选题' }}</span>
              <h1 class="exam-question-title" v-html="questionData.question"></h1>
            </div>

            <div v-if="questionData" class="options-list">
              <div
                v-for="answer in questionData.answer"
                :key="answer.answerId"
                class="option-card"
                :class="{ selected: isAnswerSelected(answer.answerId) }"
                @click="toggleAnswer(answer.answerId)"
              >
                <div class="option-circle">
                  <van-icon name="success" size="12" class="option-check" />
                </div>
                <span class="option-text" v-html="answer.body"></span>
              </div>
            </div>
          </div>
        </transition>
      </main>

      <!-- FIXED FOOTER NAV -->
      <footer class="exam-footer">
        <div class="exam-footer-inner">
          <button
            type="button"
            class="nav-btn nav-btn-prev"
            :disabled="questionIndex <= 0 || buttonLoading"
            @click="onUpQuestion"
          >
            上一题
          </button>

          <button
            type="button"
            class="nav-btn nav-btn-next"
            :disabled="buttonLoading"
            @click="isLastQuestion ? openSubmitModal() : onDownQuestion()"
          >
            <van-loading v-if="buttonLoading" size="16" type="spinner" class="nav-btn-spinner" />
            <template v-else>
              <span>{{ isLastQuestion ? '提交试卷' : '下一题' }}</span>
              <van-icon v-if="!isLastQuestion" name="arrow" size="12" class="nav-btn-arrow" />
            </template>
          </button>
        </div>
      </footer>

      <!-- SUBMIT CONFIRMATION MODAL -->
      <div class="modal-mask" :class="{ show: showSubmitModal }">
        <div class="modal-backdrop" @click="closeSubmitModal"></div>
        <div class="modal" role="dialog" aria-modal="true">
          <div class="modal-content">
            <div class="modal-icon">
              <van-icon name="description" size="20" />
            </div>
            <div class="modal-title">确认交卷？</div>
            <div class="modal-desc">提交后将无法修改答案，确定要提交吗？</div>
            <div class="modal-actions">
              <button class="modal-btn modal-btn-secondary" type="button" @click="closeSubmitModal">再检查一下</button>
              <button class="modal-btn modal-btn-primary" type="button" @click="confirmSubmit">确认交卷</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <followWx v-model="showFollow" @finish="onFollowFinish" />
  </div>
</template>

<script>
import request from '@/utils/request'
import { Button, RadioGroup, Radio, CountDown, Loading, Tag, Popup, Icon,Image } from 'vant'
import { getUserBase, MyNotify, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetBaseTitle, GetColorMainLine } from '@/utils/base'
import followWx from '@/components/followWx'

export default {
  name: 'DiveExam',
  components: {
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [CountDown.name]: CountDown,
    [Loading.name]: Loading,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Image.name]: Image,
    followWx
  },
  data() {
    return {
      // ---- 旧代码 data()：保持变量名不变（逻辑源） ----
      titleTop: '',
      title: '在线测试',
      backurl: '/divetrip/myExam',
      examStart: false,
      studentId: undefined,
      examId: undefined,
      hashCode: undefined,
      buttonLoading: false,
      data: {
        baseData: undefined,
        questionList: []
      },
      questionData: undefined,
      questionSelect: [],
      questionIndex: 0,
      saveSelectListStr: undefined,
      autoCacheTick: undefined,
      autoSaveing: undefined,
      showList: false,
      formData: {
        selectList: [],
        examResultId: undefined
      },
      userData: {
        icon: undefined
      },
      selectStudent: undefined,
      buttonDisable: true,
      showFollow:false,
      // ---- 新 UI 辅助状态（允许新增，不影响旧逻辑） ----
      showSubmitModal: false,
      defaultHero:
        '/img/backimg/exam.jpg'
    }
  },
  computed: {
    progressPercent() {
      const total = this.data && this.data.baseData ? Number(this.data.baseData.totalNum || 0) : 0
      if (!total) return 0
      return Math.min(100, Math.max(0, Math.round(((this.questionIndex + 1) / total) * 100)))
    },
    isLastQuestion() {
      const total = this.data && this.data.baseData ? Number(this.data.baseData.totalNum || 0) : 0
      return total > 0 && this.questionIndex + 1 >= total
    },
    startBtnDisabled() {
      // 与旧模板保持一致
      if (!this.data || !this.data.baseData) return true
      if (this.data.baseData.examResultId) return false
      return (!this.selectStudent || !this.selectStudent.isCanExam)
    },
    passScoreText() {
      // 新 UI 上展示及格分；如后端无字段则回退 80%
      const base = this.data && this.data.baseData ? this.data.baseData : {}
      const v = base.passScore || base.passRate || base.passPercent
      if (v === 0) return '0%'
      if (typeof v === 'number') return `${v}%`
      if (typeof v === 'string' && v.trim()) return v
      return '80%'
    },
    studentName() {
      if (this.selectStudent) {
        const parts = [this.selectStudent.className, this.selectStudent.lastName, this.selectStudent.firstName]
          .filter(Boolean)
          .join(' ')
          .replace(/\s+/g, ' ')
          .trim()
        return parts || '未选择'
      }
      return '未选择'
    },
    studentInitials() {
      if (this.selectStudent) {
        const a = (this.selectStudent.lastName || '').trim()
        const b = (this.selectStudent.firstName || '').trim()
        const i1 = a ? a.slice(0, 1).toUpperCase() : ''
        const i2 = b ? b.slice(0, 1).toUpperCase() : ''
        const initials = (i1 + i2).trim()
        return initials || (this.selectStudent.className ? this.selectStudent.className.slice(0, 2) : 'JD')
      }
      return 'JD'
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.autoCacheTick) {
      console.log('释放 autoCacheTick')
      window.clearInterval(this.autoCacheTick)
      this.autoCacheTick = undefined
    }
    next()
  },
  created() {
    getUserBase(data => {
      this.titleTop = GetBaseTitle()
      this.userData = data
    }, true)

    this.examId = getUrlKey('examId')
    this.hashCode = getUrlKey('hashCode')
    this.studentId = getUrlKey('studentId')
    this.initExamBegin()
    console.log("popstate")
    window.addEventListener('popstate', this.handleWechatBack);
  },
  methods: {
    // ---- 旧 methods：保留业务逻辑与接口 ----
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetBaseTitle,
    GetEnumText,
    formatDate,

    GetUserName(){
      if(this.userData.localName)
      {
        return this.userData.localName;
      }
      if(this.userData.firstName)
      {
        return this.userData.firstName+" "+this.userData.lastName;
      }
      return this.userData.nickName;
    },
  // 处理返回事件
    handleWechatBack(event) {
      event.preventDefault();
      console.log("handleWechatBack")
      
      // 跳转到指定页面
      this.$router.replace('/divetrip/myExam');
    },
    handleBack() {
      // 保留 backurl 的行为（旧 TopBar 的 back-url）
      if (this.$router && this.backurl) {
        this.$router.push(this.backurl)
      } else if (window && window.history) {
        window.history.back()
      }
    },

    onSelectStudent() {
      var list = this.data.baseData.examStudentInfo.filter(item => item.studentId === this.studentId)
      if (list.length > 0) {
        this.selectStudent = list[0]
      } else {
        this.selectStudent = null
      }
      console.log('onSelectStudent', this.selectStudent)
    },

    initExamBegin() {
      request({
        url: '/DiveLearn/getExamStart',
        method: 'post',
        data: {
          studentId: this.studentId,
          examId: this.examId,
          hashCode: this.hashCode
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data.baseData = response.data
        if (this.data.baseData.examStudentInfo.length === 1) {
          this.studentId = this.data.baseData.examStudentInfo[0].studentId
          this.selectStudent = this.data.baseData.examStudentInfo[0]
        } else if (this.data.baseData.examStudentInfo.length >= 1) {
          this.studentId = undefined
          this.selectStudent = undefined
        }
      })
    },

    initExam(callback) {
      request({
        url: '/DiveLearn/getExam',
        method: 'post',
        data: {
          studentId: this.studentId,
          examId: this.examId,
          hashCode: this.hashCode
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.data.questionList.forEach(question => {
          if (question.isMultiple) {
            question.select = []
          } else {
            question.select = undefined
          }
        })
        this.data.selectList.forEach(id => {
          this.data.questionList.forEach(question => {
            question.answer.forEach(answer => {
              if (answer.answerId === id) {
                if (question.isMultiple) {
                  question.select.push(id)
                } else {
                  question.select = id
                }
              }
            })
          })
        })
        this.saveSelectListStr = this.getSelectList().join(',')
        this.buttonLoading = false
        if (callback) {
          callback()
        }
      })
    },
    onFollowFinish(){
      console.log("onFollowFinish")
      this.buttonDisable = false
      this.onStart()
    },
    onStart() {
      if (!this.data.baseData.examResultId) {
        if (this.data.baseData.examStudentInfo.length > 1) {
          if (!this.studentId) {
            MyNotify('info', '请选择参与测验的顾客')
            return
          }
        }
      }
      if (this.buttonDisable === true) {
        this.showFollow = true
        return
      }
      this.buttonLoading = true
      this.initExam(() => {
        this.examStart = true
        this.questionIndex = 0
        this.onLoadQuestion()
        if (this.autoCacheTick) {
          window.clearInterval(this.autoCacheTick)
        }
        console.log('初始化autoCacheTick')
        this.autoCacheTick = setInterval(() => {
          console.log('执行autoCacheTick')
          this.updateExamSelectQuestionList()
        }, 1000 * 60 * 1)
      })
    },

    onUpQuestion() {
      if (this.questionIndex <= 0) {
        return
      }
      this.questionIndex--
      this.onLoadQuestion()
    },

    onDownQuestion() {
      if (this.questionIndex + 1 >= this.data.baseData.totalNum) {
        return
      }
      if (this.questionIndex + 1 >= this.data.questionList.length) {
        return
      }
      this.questionIndex++
      this.onLoadQuestion()
    },

    onLoadQuestion() {
      this.questionSelect = undefined
      this.questionData = this.data.questionList[this.questionIndex]
      this.questionSelect = this.questionData.select
    },

    onSelectQuestion(index) {
      this.showList = false
      this.questionIndex = index
      this.onLoadQuestion()
    },

    onquestionSelectChange() {
      console.log('onquestionSelectChange', this.questionSelect)
      this.questionData.select = this.questionSelect
    },

    getSelectList() {
      var list = []
      this.data.questionList.forEach(question => {
        if (question.isMultiple) {
          if (question.select && question.select.length > 0) {
            list = list.concat(question.select)
          }
        } else {
          if (question.select) {
            list.push(question.select)
          }
        }
      })
      return list
    },

    updateExamSelectQuestionList() {
      var list = this.getSelectList()
      var newStr = list.join(',')
      if (this.saveSelectListStr === newStr) {
        console.log('数据未发生变化，不提交')
        return
      }
      this.saveSelectListStr = newStr
      this.autoSaveing = true
      request({
        url: '/DiveLearn/updateExamSelectQuestionList',
        method: 'post',
        data: {
          examResultId: this.data.baseData.examResultId,
          selectIds: list
        }
      }).then(response => {
        if (!response.success) {
          this.autoSaveing = false
          return
        }
        setTimeout(() => {
          this.autoSaveing = false
        }, 500)
        setTimeout(() => {
          this.autoSaveing = undefined
        }, 1000)
      })
    },

    onClickList() {
      this.showList = true
    },

    checkHaveAnswer(question) {
      if (!question) {
        return false
      }
      if (question.isMultiple) {
        return question.select && question.select.length > 0
      } else {
        if (question.select) {
          return true
        } else {
          return false
        }
      }
    },

    // ---- 新 UI：选择答案（映射到旧数据结构 questionSelect / questionData.select） ----
    isAnswerSelected(answerId) {
      if (!this.questionData) return false
      if (this.questionData.isMultiple) {
        return Array.isArray(this.questionSelect) && this.questionSelect.indexOf(answerId) >= 0
      }
      return this.questionSelect === answerId
    },

    toggleAnswer(answerId) {
      if (!this.questionData) return

      if (this.questionData.isMultiple) {
        if (!Array.isArray(this.questionSelect)) {
          this.questionSelect = []
        }
        const idx = this.questionSelect.indexOf(answerId)
        if (idx >= 0) {
          this.questionSelect.splice(idx, 1)
        } else {
          this.questionSelect.push(answerId)
        }
      } else {
        this.questionSelect = answerId
      }

      this.onquestionSelectChange()
    },

    openSubmitModal() {
      this.showSubmitModal = true
    },

    closeSubmitModal() {
      this.showSubmitModal = false
    },

    confirmSubmit() {
      this.closeSubmitModal()
      this.onSubjectDo()
    },

    // ---- 旧提交逻辑（接口保持不变） ----
    onSubjectDo() {
      this.buttonLoading = true
      var list = this.getSelectList()
      request({
        url: '/DiveLearn/finishExam',
        method: 'post',
        data: {
          examResultId: this.data.baseData.examResultId,
          selectIds: list
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.$router.push('/divetrip/examFinish/' + response.data.examResultId + '?student=' + this.studentId)
      })
    }
  }
}
</script>

<style scoped>
* { box-sizing: border-box; }
.exam-page {
  min-height: 100vh;
  background: #f9fafb;
  color: #0a2540;
  padding-bottom: 88px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}
.view { min-height: 100vh; }


/* =========================
   Exam View (match new HTML)
   ========================= */
.exam-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-bottom: 96px; /* space for fixed footer */
}

.exam-header {
  position: sticky;
  top: 0;
  z-index: 40;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}
.exam-header-inner { max-width: 768px; margin: 0 auto; }
.exam-header-top {
  padding: 0 16px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.exam-header-qno {
  font-size: 14px;
  font-weight: 800;
  color: #6b7280;
}
.exam-header-current {
  font-size: 18px;
  font-weight: 900;
  color: #0a2540;
  margin: 0 2px;
}
.exam-header-total {
  color: #9ca3af;
  font-weight: 400;
}
.exam-timer-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f3f4f6;
  padding: 4px 12px;
  border-radius: 999px;
}
.exam-timer-icon { color: #0057ff; font-size: 12px; }
.exam-timer-text {
  font-size: 14px;
  font-weight: 900;
  color: #0a2540;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}

.exam-progress-track { height: 4px; width: 100%; background: #f3f4f6; }
.exam-progress-bar { height: 4px; background: #0057ff; transition: width 0.5s ease; }

.exam-main {
  flex: 1;
  max-width: 768px;
  margin: 0 auto;
  width: 100%;
  padding: 16px;
  position: relative;
  overflow: hidden;
}
@media (min-width: 768px) {
  .exam-main { padding: 24px; }
}

.slide-container { transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out; }
.slide-enter-active, .slide-leave-active { transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out; }
.slide-enter { opacity: 0; transform: translateX(14px); }
.slide-leave-to { opacity: 0; transform: translateX(-14px); }

.exam-question-card {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}
.exam-question-type {
  display: block;
  font-size: 12px;
  font-weight: 900;
  color: #9ca3af;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.exam-question-title {
  margin: 0;
  font-size: 18px;
  font-weight: 900;
  color: #0a2540;
  line-height: 1.7;
}
@media (min-width: 768px) {
  .exam-question-title { font-size: 20px; }
}

.exam-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  padding: 16px;
  z-index: 40;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.05);
}
.exam-footer-inner {
  max-width: 768px;
  margin: 0 auto;
  display: flex;
  gap: 16px;
}
.nav-btn {
  flex: 1;
  padding: 12px;
  border-radius: 12px;
  font-weight: 900;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: transform 0.04s ease, background 0.15s ease, opacity 0.15s ease;
}
.nav-btn:active { transform: translateY(1px); }
.nav-btn:disabled { opacity: 0.65; cursor: not-allowed; transform: none; }

.nav-btn-prev {
  background: #f9fafb;
  color: #9ca3af;
  border-color: #e5e7eb;
}
.nav-btn-next {
  background: #0057ff;
  color: #ffffff;
  border-color: #0057ff;
  box-shadow: 0 12px 30px -16px rgba(0,87,255,0.55);
}
.nav-btn-next:hover { background: #004fe8; }
.nav-btn-spinner { margin-right: 6px; }
.nav-btn-arrow { margin-left: 2px; }
/* =========================
   Start View (match new HTML)
   ========================= */
.start-view {
  display: flex;
  flex-direction: column;
}

.start-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.start-header-inner {
  max-width: 768px;
  margin: 0 auto;
  height: 64px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.start-brand {
  border: none;
  background: transparent;
  color: #0057ff;
  padding: 6px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.start-brand:active { background: #eff6ff; }
.start-brand-icon { display: block; }

.start-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 800;
  color: #6b7280;
}
.start-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #22c55e;
  animation: pulse 1.4s infinite;
}

.start-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.start-card {
  width: 100%;
  max-width: 448px;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #f3f4f6;
  box-shadow: 0 10px 40px -10px rgba(0,0,0,0.08);
}

.start-hero {
  height: 160px;
  background: #e5e7eb;
  position: relative;
}
.start-hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.start-hero-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  padding: 24px;
  background: linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0));
}
.start-hero-text { color: #fff; }
.start-badge {
  display: inline-block;
  background: #0057ff;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  padding: 4px 8px;
  border-radius: 8px;
  margin-bottom: 8px;
}
.start-title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
}

.start-content { padding: 24px; }

.start-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}
.start-stat {
  text-align: center;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid;
}
.start-stat-icon { margin-bottom: 4px; }
.start-stat-k {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  font-weight: 800;
}
.start-stat-v {
  font-size: 14px;
  font-weight: 800;
  color: #0a2540;
}
.start-stat-blue { background: #eff6ff; border-color: #dbeafe; color: #0057ff; }
.start-stat-purple { background: #f5f3ff; border-color: #ede9fe; color: #7c3aed; }
.start-stat-green { background: #ecfdf5; border-color: #d1fae5; color: #16a34a; }
.start-stat-blue .start-stat-v,
.start-stat-purple .start-stat-v,
.start-stat-green .start-stat-v { color: #0a2540; }

.start-instructions { margin-bottom: 32px; }
.start-instructions-title {
  margin: 0 0 16px;
  font-size: 14px;
  font-weight: 800;
  color: #0a2540;
  padding-bottom: 8px;
  border-bottom: 1px solid #f3f4f6;
}
.start-instructions-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 12px;
  font-size: 14px;
  color: #4b5563;
}
.start-instructions-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.start-ins-ico {
  flex: 0 0 auto;
  color: #0057ff;
  margin-top: 2px;
}
.start-ins-svg {
  width: 14px;
  height: 14px;
  display: block;
}
.start-strong { color: #0a2540; font-weight: 800; }

.start-student {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: 10px;
  margin-bottom: 24px;
}
.start-avatar {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: #0a2540;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
}
.start-avatar img{
  width: 40px;
  height: 40px;
  border-radius: 40px;
  overflow: hidden;
}
.start-student-meta { flex: 1; min-width: 0; }
.start-student-k {
  font-size: 12px;
  color: #9ca3af;
  text-transform: uppercase;
  font-weight: 800;
}
.start-student-v {
  font-size: 14px;
  font-weight: 800;
  color: #0a2540;
  word-break: break-word;
}
.start-student-ok { color: #22c55e; flex: 0 0 auto; }

.start-student-picker { margin-bottom: 16px; }
.start-picker-title { font-size: 12px; font-weight: 800; color: #6b7280; margin-bottom: 8px; }
.start-picker-radio {
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  padding: 10px 12px;
}
.start-picker-line { display: block; padding: 6px 0; font-size: 12px; color: #374151; }

.start-btn {
  width: 100%;
  border: none;
  background: #0057ff;
  color: #ffffff;
  font-weight: 800;
  padding: 16px 16px;
  border-radius: 12px;
  box-shadow: 0 12px 22px rgba(0, 87, 255, 0.30);
  transition: transform 0.12s ease, filter 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}
.start-btn:active { transform: scale(0.95); }
.start-btn:hover { filter: brightness(0.94); }
.start-btn-arrow { transition: transform 0.2s ease; }
.start-btn:hover .start-btn-arrow { transform: translateX(4px); }
.start-btn-spinner { margin-right: 6px; }

.btn-disabled {
  background: #e5e7eb !important;
  color: #9ca3af !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}

.start-note {
  margin: 16px 0 0;
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
}

.start-footer {
  padding: 24px 0;
  text-align: center;
}
.start-footer-text {
  margin: 0;
  font-size: 12px;
  color: #9ca3af;
}

.mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace; }
.muted { color: #9ca3af; }

.header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.header-inner {
  max-width: 520px;
  margin: 0 auto;
  height: 64px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.icon-btn {
  width: 38px;
  height: 38px;
  border: none;
  background: transparent;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #4b5563;
  cursor: pointer;
}
.icon-btn:active { background: #f3f4f6; }

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.brand-mark {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background: #0057ff;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.brand-icon { display: block; }
.brand-text {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.2px;
  white-space: nowrap;
}
.brand-text-accent { color: #0057ff; font-weight: 500; }

.status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-size: 12px;
  font-weight: 700;
}
.pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #22c55e;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6);
  animation: pulse 1.4s infinite;
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6); }
  70% { box-shadow: 0 0 0 10px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}

.header-center { flex: 1; min-width: 0; }
.header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 800;
  color: #0a2540;
  line-height: 1;
}
.autosave-icon { margin-left: 4px; }
.autosave-tag { margin-left: 6px; }

.timer {
  flex: 0 0 auto;
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
}
.timer-text { font-size: 12px; color: #6b7280; }

.progress {
  margin-top: 10px;
  height: 6px;
  background: #eef2ff;
  border-radius: 999px;
  overflow: hidden;
}
.progress-bar {
  height: 100%;
  background: #0057ff;
  width: 0%;
  transition: width 0.25s ease;
}

.main {
  max-width: 520px;
  margin: 0 auto;
  padding: 16px;
}
.exam-main { padding-bottom: 10px; }

.start-card {
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 10px 40px -10px rgba(0,0,0,0.08);
}
.hero { height: 160px; position: relative; background: #e5e7eb; }
.hero-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.hero-overlay {
  position: absolute;
  inset: 0;
  padding: 18px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(to top, rgba(0,0,0,0.62), rgba(0,0,0,0));
  color: #fff;
}
.hero-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 8px;
  background: #0057ff;
  font-size: 11px;
  font-weight: 800;
  margin-bottom: 8px;
}
.hero-title { font-size: 18px; font-weight: 800; line-height: 1.2; letter-spacing: 0.2px; }
.start-body { padding: 16px 16px 18px; }

.stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}
.stat {
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 12px 10px;
  text-align: center;
}
.stat-icon {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
}
.stat-icon-blue { background: #eff6ff; color: #0057ff; border: 1px solid #dbeafe; }
.stat-icon-purple { background: #f5f3ff; color: #7c3aed; border: 1px solid #ede9fe; }
.stat-icon-green { background: #ecfdf5; color: #16a34a; border: 1px solid #d1fae5; }
.stat-k {
  font-size: 11px;
  color: #6b7280;
  font-weight: 800;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  margin-bottom: 4px;
}
.stat-v { font-size: 13px; font-weight: 800; color: #0a2540; }

.rules { border-top: 1px solid #f3f4f6; padding-top: 14px; margin-top: 8px; }
.section-title {
  font-size: 12px;
  font-weight: 900;
  color: #0057ff;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-bottom: 10px;
}
.rules-content { font-size: 13px; line-height: 1.7; color: #374151; word-break: break-word; }
.rules-content img { max-width: 100%; height: auto; }

.start-actions { margin-top: 16px; }
.student-select { margin-top: 14px; }
.student-title { font-size: 12px; font-weight: 800; color: #6b7280; margin-bottom: 8px; }
.student-radio { background: #fafafa; border: 1px solid #f3f4f6; border-radius: 14px; padding: 10px 12px; }
.student-line { display: block; padding: 6px 0; font-size: 12px; color: #374151; }

.warn {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid #fee2e2;
  background: #fff1f2;
  color: #991b1b;
  font-size: 12px;
  line-height: 1.5;
}
.remain { margin-top: 10px; font-size: 12px; color: #6b7280; text-align: center; }
.remain-timer { display: inline-block; margin-left: 6px; }

.question-card {
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 18px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03);
  margin-bottom: 14px;
}
.q-meta { margin-bottom: 8px; }
.q-type {
  display: inline-block;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #9ca3af;
}
.q-title { font-size: 16px; font-weight: 800; line-height: 1.6; color: #0a2540; word-break: break-word; }
.q-title img { max-width: 100%; height: auto; }

.options { margin-bottom: 12px; }
.option-card {
  padding: 16px;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}
.option-card:hover { background-color: #F3F4F6; }
.option-card.selected {
  border-color: #0057FF;
  background-color: #EFF6FF;
  box-shadow: 0 4px 6px -1px rgba(0, 87, 255, 0.1);
}

.option-circle {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 2px solid #D1D5DB;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
  background: transparent;
  color: #ffffff;
}
.option-check { opacity: 0; transition: opacity 0.2s ease; }
.option-card.selected .option-circle { border-color: #0057FF; background-color: #0057FF; }
.option-card.selected .option-check { opacity: 1; }

.option-text {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  line-height: 1.5;
  word-break: break-word;
}
.option-card.selected .option-text { color: #0057FF; }
.option-card.selected .option-text { color: #0057ff; }

.analysis-card {
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 18px;
  padding: 14px 16px;
  color: #6b7280;
  margin-top: 8px;
}
.analysis-title { font-size: 12px; font-weight: 900; color: #0a2540; margin-bottom: 6px; }
.analysis-body { font-size: 13px; line-height: 1.6; }

.spacer { height: 90px; }

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.92);
  border-top: 1px solid #e5e7eb;
  backdrop-filter: blur(10px);
  z-index: 60;
}
.footer-inner {
  max-width: 520px;
  margin: 0 auto;
  padding: 14px 16px;
  display: flex;
  gap: 10px;
}

.btn {
  flex: 1;
  height: 44px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px;
  transition: transform 0.04s ease, background 0.15s ease, opacity 0.15s ease;
}
.btn:active { transform: translateY(1px); }
.btn:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }
.btn-primary { background: #0057ff; color: #fff; box-shadow: 0 12px 30px -16px rgba(0,87,255,0.55); }
.btn-primary:hover { background: #004fe8; }
.btn-secondary { background: #ffffff; color: #0a2540; border: 1px solid #e5e7eb; }
.btn-secondary:hover { background: #f9fafb; }
.btn-inline { font-weight: 800; }
.btn-spinner { margin-right: 6px; }

.list-popup { padding: 14px 14px 18px; }
.list-title {
  text-align: center;
  font-size: 14px;
  font-weight: 900;
  padding-bottom: 10px;
  border-bottom: 1px solid #f3f4f6;
}
.list-grid {
  padding-top: 12px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px;
  max-height: 55vh;
  overflow: auto;
}
.list-item {
  height: 34px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #6b7280;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}
.list-item.answered { color: #0057ff; border-color: rgba(0,87,255,0.25); background: #eff6ff; }
.list-item.active { outline: 2px solid rgba(0,87,255,0.25); }

.modal-mask {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  padding: 18px;
}
.modal-mask.show { opacity: 1; pointer-events: auto; }

.modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(6px);
}

.modal {
  position: relative;
  width: 85%;
  max-width: 360px;
  background: #ffffff;
  border-radius: 22px;
  padding: 24px;
  box-shadow: 0 24px 60px rgba(0,0,0,0.28);
  transform: scale(0.95);
  transition: transform 0.3s ease;
}
.modal-mask.show .modal { transform: scale(1); }

.modal-content { text-align: center; }

.modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 999px;
  background: #eff6ff;
  color: #0057ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
}
.modal-title { text-align: center; font-size: 18px; font-weight: 900; margin-bottom: 8px; }
.modal-desc { text-align: center; font-size: 14px; color: #6b7280; margin-bottom: 18px; line-height: 1.6; }

.modal-actions { display: flex; gap: 12px; }

.modal-btn {
  flex: 1;
  padding: 12px 0;
  border-radius: 12px;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 900;
  transition: transform 0.04s ease, background 0.15s ease, opacity 0.15s ease;
}
.modal-btn:active { transform: translateY(1px); }
.modal-btn-secondary {
  background: #f9fafb;
  border-color: #e5e7eb;
  color: #374151;
}
.modal-btn-secondary:hover { background: #f3f4f6; }
.modal-btn-primary {
  background: #0057ff;
  color: #ffffff;
  box-shadow: 0 12px 30px -16px rgba(0,87,255,0.55);
}
.modal-btn-primary:hover { background: #004fe8; }
</style>
